export const ApplyJobEnums = Object.freeze({
  JOB_STATUS_CLOSED: "Closed",
});
